import React from 'react';

function DropDownEditor(props) {

    if (typeof(props.id) != 'string') {
        throw new TypeError("Required ID prop has not been set")
    }

    const onEditorChange = (e) => {
        // Bubble the event up to the calling component
        if (props.onChange) {
            props.onChange({ originalEvent: e, value: e.target.value, props: props });
        }
    }

    var selectedValue = props.value;
    if(selectedValue === null){
        selectedValue = "";
    }
    
    return (
        (props.naked ?
            <select value={selectedValue} onChange={onEditorChange}>
            {props.options !== undefined && (Object.keys(props.options).map(key => (
                <option value={key} key={key}>{props.options[key]}</option>
            )))}
            {props.sortedOptions !== undefined && (props.sortedOptions.map(opt => (
                <option value={opt.Value} key={opt.Value}>{opt.Label}</option>
            )))}
            </select>
            :
        <td className={props.className || "control"} colSpan={props.colSpan}>
            <select value={selectedValue} onChange={onEditorChange}>
            {props.options !== undefined && (Object.keys(props.options).map(key => (
                <option value={key} key={key}>{props.options[key]}</option>
            )))}
            {props.sortedOptions !== undefined && (props.sortedOptions.map(opt => (
                <option value={opt.Value} key={opt.Value}>{opt.Label}</option>
            )))}
            </select>
        </td>
        )
    )
}

export default DropDownEditor;